import { Link } from "react-router-dom";
import { OvalLoader } from "../../../components/common/Loader";
import { BRAND, GRADIENTS } from "../../../constant/theme";

const InsightCard = ({
  title,
  data,
  loading,
  emptyIcon,
  emptyTitle,
  emptyDesc,
  gradient,
  linkTo,
  actionTitle,
  actionSubtitle,
  patternType = "wave",
}) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4">
      <div
        className="card text-white h-100 dashboard-insight-glass-card"
        style={{
          background: gradient,
          position: "relative",
          border: "none",
        }}
      >
        {patternType === "wave" && (
          <svg
            width="200"
            height="150"
            viewBox="0 0 200 150"
            className="insight-pattern"
            style={{ top: 0, right: 0 }}
          >
            <path
              d="M 200 0 L 200 150 C 150 150 100 100 0 0 Z"
              fill="rgba(255, 255, 255, 0.05)"
            />
            <path
              d="M 200 0 L 200 80 C 160 80 120 40 50 0 Z"
              fill="rgba(255, 255, 255, 0.08)"
            />
          </svg>
        )}
        {patternType === "circles" && (
          <svg
            width="200"
            height="200"
            viewBox="0 0 200 200"
            className="insight-pattern"
            style={{ top: -50, right: -20 }}
          >
            <circle cx="100" cy="100" r="100" fill="rgba(255, 255, 255, 0.03)" />
            <circle cx="100" cy="100" r="70" fill="rgba(255, 255, 255, 0.05)" />
            <circle cx="100" cy="100" r="40" fill="rgba(255, 255, 255, 0.08)" />
          </svg>
        )}
        {patternType === "diamonds" && (
          <svg
            width="180"
            height="180"
            viewBox="0 0 180 180"
            className="insight-pattern"
            style={{ top: -30, right: -10 }}
          >
            <polygon
              points="90,0 180,90 90,180 0,90"
              fill="rgba(255, 255, 255, 0.03)"
            />
            <polygon
              points="90,30 150,90 90,150 30,90"
              fill="rgba(255, 255, 255, 0.05)"
            />
            <polygon
              points="90,60 120,90 90,120 60,90"
              fill="rgba(255, 255, 255, 0.08)"
            />
          </svg>
        )}

        <div
          className="card-body d-flex flex-column"
          style={{ position: "relative", zIndex: 1, padding: "1.5rem" }}
        >
          <h6
            className="text-white mb-4"
            style={{ fontWeight: "600", fontSize: "1.05rem", opacity: 0.9 }}
          >
            {title}
          </h6>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center flex-grow-1">
              <OvalLoader color="#ffffff" />
            </div>
          ) : data?.length > 0 ? (
            <div className="d-flex flex-column flex-grow-1">
              <div
                className="avatar-group insight-avatar-group d-flex align-items-center justify-content-start mt-2 mb-4 flex-wrap"
              >
                {data.slice(0, 5).map((user, i) => (
                  <div
                    key={i}
                    className="avatar avatar-md"
                    title={`${user?.name || "Member"}`}
                    style={{
                      borderRadius: "50%",
                      marginLeft: i !== 0 ? "-12px" : "0",
                      width: "42px",
                      height: "42px",
                    }}
                  >
                    <img
                      src={
                        user?.thumb_profile_image ||
                        user?.profile_image ||
                        "/profile-default.png"
                      }
                      alt="Avatar"
                      className="rounded-circle"
                      style={{
                        objectFit: "cover",
                        width: "100%",
                        height: "100%",
                      }}
                    />
                  </div>
                ))}
                {data.length > 5 && (
                  <div
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      borderRadius: "50%",
                      width: "42px",
                      height: "42px",
                      backgroundColor: "rgba(255,255,255,0.2)",
                      marginLeft: "-12px",
                      zIndex: 10,
                    }}
                  >
                    <span className="fw-bold text-white fs-6">
                      +{data.length - 5}
                    </span>
                  </div>
                )}
              </div>

              <p
                style={{
                  color: BRAND.accentYellow,
                  fontWeight: "600",
                  marginBottom: "4px",
                  fontSize: "0.9rem",
                }}
              >
                {data.length} {actionSubtitle}
              </p>
              <h5
                className="text-white mb-3"
                style={{ fontWeight: "700", fontSize: "1.3rem" }}
              >
                {actionTitle}
              </h5>

              <Link
                to={linkTo}
                className="d-flex align-items-center text-decoration-none mt-auto align-self-end"
                style={{
                  backgroundColor: "rgba(255,255,255,0.25)",
                  color: "#ffffff",
                  padding: "8px 16px",
                  borderRadius: "8px",
                  backdropFilter: "blur(4px)",
                  transition: "0.2s",
                }}
              >
                <span
                  className="fw-semibold me-2 d-none d-sm-block"
                  style={{ fontSize: "0.85rem" }}
                >
                  View Report
                </span>
                <i
                  className="bx bx-right-arrow-alt"
                  style={{ fontSize: "1.2rem" }}
                ></i>
              </Link>
            </div>
          ) : (
            <div
              className="d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center h-100 mt-2"
            >
              <div style={{ fontSize: "3rem", marginBottom: "15px" }}>
                {emptyIcon}
              </div>
              <h5
                style={{
                  color: "#ffffff",
                  fontWeight: "700",
                  marginBottom: "8px",
                }}
              >
                {emptyTitle}
              </h5>
              <p
                className="mb-0"
                style={{
                  color: "rgba(255,255,255,0.85)",
                  fontSize: "0.85rem",
                  lineHeight: "1.5",
                }}
              >
                {emptyDesc}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const PendingListsTables = ({ data, loading, hasPermission }) => {
  return (
    <>
      {hasPermission("dashboard-monthly-fees-pending-list-view") && (
        <InsightCard
          title="Pending Monthly Fees"
          data={data?.monthlyFeesPendingList}
          loading={loading}
          emptyIcon="🎉"
          emptyTitle="All Fees Collected!"
          emptyDesc="Great job! There are no pending payments for this month."
          gradient={GRADIENTS.pendingMeetingFees}
          linkTo="/reports/fees"
          actionSubtitle={
            data?.monthlyFeesPendingList?.length === 1
              ? "Member Fees Pending"
              : "Members Fees Pending"
          }
          actionTitle="Follow Up on Payments!"
          patternType="circles"
        />
      )}
      {hasPermission("dashboard-weekly-meeting-not-attended-list-view") && (
        <InsightCard
          title="Meetings Absentees List"
          data={data?.weeklyMeetingPendingList}
          loading={loading}
          emptyIcon="🌟"
          emptyTitle="All Attending!"
          emptyDesc="Everyone is present. Excellent attendance this week!"
          gradient={GRADIENTS.meetingAbsentees}
          linkTo="/reports/attendance"
          actionSubtitle={
            data?.weeklyMeetingPendingList?.length === 1
              ? "Member Absent"
              : "Members Absent"
          }
          actionTitle="Review Attendance!"
        />
      )}
    </>
  );
};

export default PendingListsTables;
